import React from "react";
import { EditableArea } from "@magnolia/react-editor";

// The dialog shares the corporate grid's layout format: column spans separated by "|",
// e.g. "2|1" for 66% / 33%. The spans are mapped onto Bootstrap's 12-column row; every
// layout the dialog offers divides 12 without a remainder. Mobile is always one column.
const LEGACY_COLUMNS = { 1: "1", 2: "1|1", 3: "1|1|1", 4: "1|1|1|1" };

const parseSpans = (layout) =>
    String(layout || "")
        .split("|")
        .map((span) => parseInt(span, 10))
        .filter((span) => span > 0)
        .slice(0, 4);

const spanClasses = (spans, breakpoint) => {
    const total = spans.reduce((sum, span) => sum + span, 0);
    return spans.map((span) => `col-${breakpoint}-${Math.round((span / total) * 12)}`);
};

const isTrue = (value) => value === true || value === "true";

const Grid = (props) => {
    // Grids authored before the layout field stored a plain column count.
    let spans = parseSpans(props.layout || LEGACY_COLUMNS[parseInt(props.columns, 10)]);
    if (!spans.length) spans = [1, 1];

    // The tablet layout knows one or two columns; further desktop columns wrap onto new
    // tablet rows and repeat the pattern, as the FTL grid does.
    let tabletSpans = parseSpans(props.tabletLayout);
    if (!tabletSpans.length) tabletSpans = [1];

    const desktop = spanClasses(spans, "lg");
    const tablet = spanClasses(tabletSpans, "md");

    return (
        <div className="container">
            <div className={["row gy-5", isTrue(props.centerVertically) ? "align-items-center" : ""].filter(Boolean).join(" ")}>
                {spans.map((_, i) => {
                    // Area nodes only exist once a column has been edited.
                    const area = props[`column${i + 1}`];

                    return (
                        <div className={`col-12 ${tablet[i % tablet.length]} ${desktop[i]}`} key={i}>
                            {area && <EditableArea content={area} className="component-stack--tight" />}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Grid;
